import type React from "react"
import { FaPen } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import "./WriteFab.css"

export const WriteFab: React.FC = () => {
  const navigate = useNavigate()

  return (
    <button className="write-fab" onClick={() => { void navigate("/community/write"); }}>
      <FaPen />
      <span>글쓰기</span>
    </button>
  )
}
